import * as React from 'react';
import { useNavigate } from 'react-router';
import type { PiletApi } from '@chess/platform-web';
import { libraryLink, type FilterLink } from '@chess/api-insights/charts';
import { registerAggregator, useAggregate } from '@chess/api-model/react';
import { HELP_API, type Help } from '@chess/api-help';
import { registerCard } from '@chess/api-dashboard';
import { MIDDLEGAME_RESULTS_HELP, middlegameResultsHelp } from './help.tsx';
import '@chess/api-insights/charts.css';
import { MIDDLEGAME_RESULTS_CARD, MiddlegameResultsCard } from './MiddlegameResultsCard.tsx';
import { MiddlegameResultsAggregator } from './MiddlegameResultsAggregator.ts';

// Middlegame card "Middlegame results": registers its aggregator with the
// game store and its body `MiddlegameResultsCard` (`registerCard`: the
// section draws the frame) first among the Middlegame
// section's top cards (`home.section.middlegame`, order 5, before Middlegame
// misses and Middlegame swings), which Home's Middlegame section and the
// Middlegame screen both show. Slices open the library filtered to those
// games (`libraryLink`, last 30 days).
export function setup(app: PiletApi) {
  const getApi = <T,>(name: string) => app.getApi<T>(name);
  const aggregator = new MiddlegameResultsAggregator();
  registerAggregator(getApi, aggregator);
  void app.getApi<Help>(HELP_API).then((help) => help.register(MIDDLEGAME_RESULTS_HELP, middlegameResultsHelp));
  const Card: React.FC = () => {
    const { result, state } = useAggregate(getApi, aggregator);
    const navigate = useNavigate();
    const link = React.useMemo<FilterLink>(() => libraryLink((path) => navigate(path)), [navigate]);
    // Never hidden while the store loads: the card shows skeletons for its values.
    if (state?.status !== 'ready') return state?.status === 'failed' ? null : <MiddlegameResultsCard loading />;
    return result ? <MiddlegameResultsCard result={result} link={link} /> : null;
  };
  registerCard(app, 'home.section.middlegame', Card, { order: 5, ...MIDDLEGAME_RESULTS_CARD });
}
